import { IMondayContext } from '@/types/response/monday/context';
import { useAppQuery } from '.';
import { API_ROUTES } from '@/constants/api-routes';
import queryKeys from '@/constants/queryKeys';
import { UseQueryOptions } from 'react-query';

export interface IAppProgressResponse {
  applicationStatus: 'initialized' | 'info-page-displayed';
  envelopeStatus: 'initialized' | 'settings-configured';
}

export const useGetProgressQuery = (
  context?: IMondayContext,
  options?: UseQueryOptions<IAppProgressResponse>,
) => {
  return useAppQuery<IAppProgressResponse>({
    routeName: API_ROUTES.GET_PROGRESS_STATUS,
    queryKey: [queryKeys.GET_PROGRESS_STATUS],
    method: 'GET',
    requestConfig: {
      routeParams: {
        instanceId: context?.instanceId,
        boardId: context?.boardId,
      },
    },
    options: {
      enabled: !!context,
      ...options,
      retry: (_, error: any) => {
        if (error?.response?.status === 401) return false;
        return false; // Don't retry for any other errors either
      },
    },
  });
};
